<template>
    <div class="apprentice-simple-card profile-access-management">
        <div class="muted-text">
            {{ $t('school.select_here_which_teachers_have_access_to_which_profiles') }}
        </div>

        <div class="accesses">
            <b-tabs
                v-model="accessTab"
                content-class="mt-3">
                <b-tab
                    :title="$t('school.students')"
                    active>
                        <v-server-table
                            ref="serverTable"
                            :url="url"
                            :columns="columns"
                            :options="options"
                            name="student-table">
                            <div slot="teachers"
                                 slot-scope="{ row }">
                                <div
                                    class="las-teacher"
                                    v-for="teacher in row.teachers">
                                    {{ teacher.user.full_name }}

                                    <b-button
                                        class="btn-information-icon"
                                        v-if="
                                            (teacher.groups && teacher.groups.length) ||
                                            (teacher.las_groups && teacher.las_groups.length) ||
                                            (teacher.las_main_groups && teacher.las_main_groups.length) ||
                                            (teacher.modules && teacher.modules.length)
                                        "
                                        variant="primary-icon-only"
                                        :id="`las-teacher-${row.id}-${teacher.id}`">
                                    </b-button>

                                    <b-popover
                                        :target="`las-teacher-${row.id}-${teacher.id}`"
                                        triggers="hover"
                                        placement="right">
                                        <div v-if="teacher.groups && teacher.groups.length">
                                            <b>{{ $t('school.groups') }}</b>
                                            <ul>
                                                <li v-for="group in teacher.groups">
                                                    {{ group.name }}
                                                </li>
                                            </ul>
                                        </div>

                                        <div v-if="teacher.las_groups && teacher.las_groups.length">
                                            <b>{{ $t('school.las_groups') }}</b>
                                            <ul>
                                                <li v-for="group in teacher.las_groups">
                                                    {{ group.name }}
                                                </li>
                                            </ul>
                                        </div>

                                        <div v-if="teacher.las_main_groups && teacher.las_main_groups.length">
                                            <b>{{ $t('school.las_main_groups') }}</b>
                                            <ul>
                                                <li v-for="group in teacher.las_main_groups">
                                                    {{ group.name }}
                                                </li>
                                            </ul>
                                        </div>

                                        <div v-if="teacher.modules && teacher.modules.length">
                                            <b>Modules:</b>
                                            <ul>
                                                <li v-for="group in teacher.modules">
                                                    {{ group.title }}
                                                </li>
                                            </ul>
                                        </div>
                                    </b-popover>
                                </div>
                            </div>
                            <div slot="actions"
                                 slot-scope="{ row }">
                                <b-button
                                    class="btn-edit btn-edit-student"
                                    variant="primary-icon-only"
                                    @click="onClickAccessStudent(row)">
                                </b-button>
                            </div>
                        </v-server-table>
                </b-tab>
                <b-tab
                    v-if="schoolIn.las_location && schoolIn.las_location.checked === 1"
                    :title="$t('school.groups')">
                    <div v-if="lasGroups && lasGroups.length">
                        <design-2021-apprentice-data-table
                            :items="lasGroups"
                            :fields="groupFields">
                            <template v-slot:cell(name)="data">
                                <span
                                ><b>{{ data.item.name }}</b></span
                                >
                                <span style="color: gray">({{ data.item.season.season }})</span>
                            </template>

                            <template v-slot:cell(teachers)="data">
                                <div
                                    v-for="teacher in data.item.teachers"
                                    style="margin-bottom: 10px">
                                    <span>{{ teacher.full_name }}</span>
                                </div>
                                <div
                                    v-for="teacher in data.item.profile_accesses"
                                    style="margin-bottom: 10px">
                                    <span>{{ teacher.full_name }}</span>
                                </div>
                            </template>

                            <template v-slot:cell(actions)="data">
                                <b-button
                                    class="btn-edit btn-edit-groups"
                                    variant="primary-icon-only"
                                    @click="onClickAccessGroup(data.item)">
                                </b-button>
                            </template>
                        </design-2021-apprentice-data-table>
                    </div>
                    <div v-else>
                        <i>{{ $t('school.no_groups_found') }}</i>
                    </div>
                </b-tab>
                <b-tab
                    v-if="schoolIn.las_location && schoolIn.las_location.checked === 1"
                    :title="$t('school.main_groups')">
                    <div v-if="lasMainGroups && lasMainGroups.length">
                        <design-2021-apprentice-data-table
                            :items="lasMainGroups"
                            :fields="groupFields">
                            <template v-slot:cell(name)="data">
                                <span
                                ><b>{{ data.item.name }}</b></span
                                >
                                <span style="color: gray">({{ data.item.season.season }})</span>
                            </template>

                            <template v-slot:cell(teachers)="data">
                                <div
                                    v-for="teacher in data.item.teachers"
                                    style="margin-bottom: 10px">
                                    <span>{{ teacher.full_name }}</span>
                                </div>

                                <div
                                    v-for="teacher in data.item.profile_accesses"
                                    style="margin-bottom: 10px">
                                    <span>{{ teacher.full_name }}</span>
                                </div>
                            </template>

                            <template v-slot:cell(actions)="data">
                                <b-button
                                    class="btn-edit btn-edit-las-groups"
                                    variant="primary-icon-only"
                                    @click="onClickAccessMainGroup(data.item)">
                                </b-button>
                            </template>
                        </design-2021-apprentice-data-table>
                    </div>
                    <div v-else>
                        <i>{{ $t('school.no_groups_found') }}</i>
                    </div>
                </b-tab>
            </b-tabs>
        </div>

        <design-2021-school-access-connect-modal-component
            ref="access-model"
            @connect-item="itemConnected($event)"
            @remove-item="itemRemoved($event)">
        </design-2021-school-access-connect-modal-component>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-school-settings-profile-access-component',
        props: ['isadminIn', 'teachersIn', 'schoolIn', 'lasGroupsIn', 'lasMainGroupsIn'],
        data() {
            return {
                accessTab: 0,
                lasGroups: this.filteredTeachersByLasGroups(),
                lasMainGroups: this.filteredTeachersByLasMainGroups(),
                groupFields: [
                    { key: 'name', label: this.$t('school.group') },
                    { key: 'teachers', label: this.$t('school.teachers') },
                    { key: 'actions', label: this.$t('common.edit') }
                ],

                url: this.routes.managementProfileGetAllStudents(),
                columns: ['full_name', 'teachers', 'actions'],
                options: {
                    headings: {
                        full_name: this.$t('school.student'),
                        teachers: this.$t('school.teachers'),
                        actions: this.$t('common.edit')
                    },
                    sortable: ['full_name'],
                    sortIcon: {
                        base: 'fad',
                        is: 'fa-sort',
                        up: 'fa-sort-up',
                        down: 'fa-sort-down'
                    },
                    saveState: true,
                    requestFunction(data) {
                        if (data.orderBy) {
                            switch (data.orderBy) {
                                case 'full_name':
                                    data.orderBy = 'surname';
                                    break;
                            }
                        }
                        return this.axios.get(this.url, { params: data });
                    }
                }
            };
        },
        methods: {
            filteredTeachersByLasGroups() {
                let lasGroups = [];

                for (const lasGroup of this.lasGroupsIn) {
                    let teachers = [];

                    for (const teacher of this.teachersIn) {
                        if (teacher.las_employee && teacher.las_employee.groups.length) {
                            for (const group of teacher.las_employee.groups) {
                                if (group.id === lasGroup.id) {
                                    teachers.push(teacher);
                                }
                            }
                        }
                    }

                    lasGroup.teachers = teachers;
                    lasGroups.push(lasGroup);
                }

                return lasGroups;
            },
            filteredTeachersByLasMainGroups() {
                let lasMainGroups = [];

                for (const lasMainGroup of this.lasMainGroupsIn) {
                    let teachers = [];

                    for (const teacher of this.teachersIn) {
                        if (teacher.las_employee && teacher.las_employee.main_groups.length) {
                            for (const mainGroup of teacher.las_employee.main_groups) {
                                if (mainGroup.id === lasMainGroup.id) {
                                    teachers.push(teacher);
                                }
                            }
                        }
                    }

                    lasMainGroup.teachers = teachers;
                    lasMainGroups.push(lasMainGroup);
                }

                return lasMainGroups;
            },
            onClickAccessStudent(student) {
                const attachedByDefaultTeacherIds = student.teachers
                    .filter((teacher) => !teacher.group_profile_access)
                    .map((teacher) => teacher.id);

                const canBeDeletedTeachers = student.teachers
                    .filter((teacher) => teacher.group_profile_access)
                    .map((teacher) => teacher.user);

                const canBeDeletedTeacherIds = canBeDeletedTeachers.map((teacher) => teacher.id);

                let canBeAddedTeachers = this.teachersIn.filter((teacher) => {
                    if (!attachedByDefaultTeacherIds.includes(teacher.id) && !canBeDeletedTeacherIds.includes(teacher.id)) {
                        return teacher;
                    }
                });

                this.$refs['access-model'].show(student.full_name, student, canBeAddedTeachers, canBeDeletedTeachers);
            },
            onClickAccessGroup(group) {
                let teachers = [];

                for (const teacher of this.teachersIn) {
                    if (!teacher.las_employee) {
                        teachers.push(teacher);
                        continue;
                    }

                    if (!teacher.las_employee.groups.length) {
                        teachers.push(teacher);
                        continue;
                    }

                    let teacherInGroup = false;

                    for (const lasGroup of teacher.las_employee.groups) {
                        if (lasGroup.id === group.id) {
                            teacherInGroup = true;
                        }
                    }

                    if (!teacherInGroup) {
                        teachers.push(teacher);
                    }
                }

                this.$refs['access-model'].show(
                    group.name,
                    group,
                    teachers.filter((teacher) => {
                        for (const t of group.profile_accesses) {
                            if (t.id === teacher.id) {
                                return false;
                            }
                        }
                        return true;
                    }),
                    teachers.filter((teacher) => {
                        for (const t of group.profile_accesses) {
                            if (t.id === teacher.id) {
                                return true;
                            }
                        }
                        return false;
                    })
                );
            },
            onClickAccessMainGroup(group) {
                let teachers = [];

                for (const teacher of this.teachersIn) {
                    if (!teacher.las_employee) {
                        teachers.push(teacher);
                        continue;
                    }

                    if (!teacher.las_employee.main_groups.length) {
                        teachers.push(teacher);
                        continue;
                    }

                    let teacherInGroup = false;

                    for (const lasMainGroup of teacher.las_employee.main_groups) {
                        if (lasMainGroup.id === group.id) {
                            teacherInGroup = true;
                        }
                    }

                    if (!teacherInGroup) {
                        teachers.push(teacher);
                    }
                }

                this.$refs['access-model'].show(
                    group.name,
                    group,
                    teachers.filter((teacher) => {
                        for (const t of group.profile_accesses) {
                            if (t.id === teacher.id) {
                                return false;
                            }
                        }
                        return true;
                    }),
                    teachers.filter((teacher) => {
                        for (const t of group.profile_accesses) {
                            if (t.id === teacher.id) {
                                return true;
                            }
                        }
                        return false;
                    })
                );
            },
            itemConnected(values) {
                this.alert.saving();

                switch (this.accessTab) {
                    case 0:
                        const data = {
                            teacher_id: values.teacher.id,
                            student_id: values.item_id
                        };

                        this.axios.post(this.routes.profileAccessStudent(), data).then(
                            (response) => {
                                let s = null;

                                this.$refs.serverTable.refresh();

                                this.onClickAccessStudent(s);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            }
                        );
                        break;
                    case 1:
                        const dataGroup = {
                            teacher_id: values.teacher.id,
                            las_group_id: values.item_id
                        };
                        this.axios.post(this.routes.profileAccessLasGroup(), dataGroup).then(
                            (response) => {
                                let g = null;
                                this.lasGroups = this.lasGroups.map((group) => {
                                    if (group.id === dataGroup.las_group_id) {
                                        group.profile_accesses.push(values.teacher);

                                        g = {
                                            id: group.id,
                                            name: group.name,
                                            profile_accesses: group.profile_accesses
                                        };
                                    }
                                    return group;
                                });
                                this.onClickAccessGroup(g);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            }
                        );
                        break;
                    case 2:
                        const dataMainGroup = {
                            teacher_id: values.teacher.id,
                            las_main_group_id: values.item_id
                        };
                        this.axios.post(this.routes.profileAccessLasMainGroup(), dataMainGroup).then(
                            (response) => {
                                let mg = null;
                                this.lasMainGroups = this.lasMainGroups.map((mainGroup) => {
                                    if (mainGroup.id === dataMainGroup.las_main_group_id) {
                                        mainGroup.profile_accesses.push(values.teacher);

                                        mg = {
                                            id: mainGroup.id,
                                            name: mainGroup.name,
                                            profile_accesses: mainGroup.profile_accesses
                                        };
                                    }
                                    return mainGroup;
                                });
                                this.onClickAccessMainGroup(mg);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            }
                        );
                        break;
                }
            },
            itemRemoved(values) {
                this.alert.saving();

                switch (this.accessTab) {
                    case 0:
                        this.axios.delete(this.routes.profileAccessStudentRemove(values.teacher_id, values.item_id)).then(
                            (response) => {
                                let s = null;

                                this.$refs.serverTable.refresh();

                                this.onClickAccessStudent(s);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            }
                        );
                        break;
                    case 1:
                        this.axios.delete(this.routes.profileAccessLasGroupRemove(values.teacher_id, values.item_id)).then(
                            (response) => {
                                let g = null;
                                this.lasGroups = this.lasGroups.map((group) => {
                                    if (group.id === values.item_id) {
                                        group.profile_accesses = group.profile_accesses.filter(
                                            (t) => t.id !== values.teacher_id
                                        );

                                        g = {
                                            id: group.id,
                                            name: group.full_name,
                                            profile_accesses: group.profile_accesses
                                        };
                                    }
                                    return group;
                                });
                                this.onClickAccessGroup(g);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            }
                        );
                        break;
                    case 2:
                        this.axios
                            .delete(this.routes.profileAccessLasMainGroupRemove(values.teacher_id, values.item_id))
                            .then(
                                (response) => {
                                    let mg = null;
                                    this.lasMainGroups = this.lasMainGroups.map((mainGroup) => {
                                        if (mainGroup.id === values.item_id) {
                                            mainGroup.profile_accesses = mainGroup.profile_accesses.filter(
                                                (t) => t.id !== values.teacher_id
                                            );

                                            mg = {
                                                id: mainGroup.id,
                                                name: mainGroup.full_name,
                                                profile_accesses: mainGroup.profile_accesses
                                            };
                                        }
                                        return mainGroup;
                                    });
                                    this.onClickAccessMainGroup(mg);
                                    this.alert.success();
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                }
                            );
                        break;
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .las-teacher {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        column-gap: map-get($grid-gutter-spacing, 'ten');
        row-gap: map-get($grid-gutter-spacing, 'eight');
    }
</style>
